module.exports = __webpack_public_path__ + "media/68f52096-d419-499e-afdb-19b966c03d2e.4a2ceeab.mp4";